// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mK2cn","left":"styles_left__13bbo","desktopActions":"styles_desktopActions__23DgM","title":"styles_title__2IQUj"};